import React, { Component } from "react";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

export class CollectionNames extends Component {
  state = {
    collection: "word_set",
    collections: [
      { name: "word_set" },
      { name: "word_temp" },
      { name: "word_french" },
      { name: "word_spanish" },
      { name: "word_german" },
    ],
  };

  handleCollectionChange = (event) => {
    this.setState({
      collection: event.target.value,
    });
    this.props.handleCollectionChange(event.target.value);
  };

  componentDidMount() {
    // this.setState({
    //     table: this.props.sets
    // });
    //console.log(this.props.sets);
  }

  render() {
    return (
      <FormControl fullWidth>
        <InputLabel htmlFor="name-Collection">Collection</InputLabel>
        <Select
          fullWidth
          value={this.state.collection}
          onChange={this.handleCollectionChange}
          inputProps={{
            name: "Collection",
            id: "name-Collection",
          }}
        >
          {typeof this.state.collections != "undefined" &&
            this.state.collections.map((se) => (
              <MenuItem value={se.name}>{se.name}</MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}

export default CollectionNames;
